import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-wrapp',
  templateUrl: './content-wrapp.component.html',
  styleUrls: ['./content-wrapp.component.scss']
})
export class ContentWrappComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
